import * as React from 'react'

function IconCancel(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={45}
      height={46}
      viewBox="0 0 45 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.696 42.39H15.304c-6.503 0-11.773-5.387-11.773-12.034V15.644c0-6.647 5.27-12.034 11.773-12.034h14.392c6.503 0 11.773 5.387 11.773 12.034v14.712c0 6.647-5.27 12.034-11.773 12.034zM14.521 14.845l15.957 16.31M30.478 14.845L14.52 31.155"
        stroke="#E84E25"
        strokeWidth={6}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconCancel
